import {
  Box,
  Card,
  Grid,
  styled,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import FAB from 'components/FAB';
import { useState } from 'react';

import { H0, H2, H5 } from 'components/Typography';

// lottie files
import SurveyModal from 'components/modal/landing/SurveyModal';
import MembershipPurchaseModal from 'components/modal/MembershipPurchaseModal';
import FlexRowAlign from '../components/flexbox/FlexRowAlign';

const StyledCard = styled(Card)(({ theme }) => ({
  width: '100%',
  marginLeft: '0px',
  backgroundColor: '#FFFFFF',
  borderRadius: 0,
  [theme.breakpoints.down('sm')]: {
    '& > .MuiBox-root': {
      paddingBottom: 0,
    },
  },
}));

export default function Membership2({ showSideBar }) {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));

  let padding;
  if (window.innerWidth > 1720 && !isTablet) {
    padding = '80px 165px';
  } else {
    padding = isTablet ? '60px 20px' : '80px 80px';
  }

  return (
    <>
      <FAB marginBottom={'60px'} />

      {/* {isMobile && (
        <BottomBar setShowKaKaoLoginModal={setShowKaKaoLoginModal} />
      )} */}

      <StyledCard showSideBar={showSideBar} sx={{ border: 'none' }}>
        <Grid container>
          <Grid item xs={12} padding={padding}>
            <PricingSection />
          </Grid>
          <Grid item xs={12} padding={padding}>
            <TextSection />
          </Grid>
          <Grid item xs={12} padding={padding}>
            <CardNewsSection />
          </Grid>
        </Grid>
      </StyledCard>
    </>
  );
}

const PricingSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));
  const [showMembershipPurchaseModal, setShowMembershipPurchaseModal] =
    useState(false);

  return (
    <>
      <MembershipPurchaseModal
        showModal={showMembershipPurchaseModal}
        setShowModal={setShowMembershipPurchaseModal}
      />

      <Grid
        sx={{
          textAlign: 'center',
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          alignItems: 'center',
          maxWidth: '1100px',
          width: '100%',
          margin: '0 auto',
        }}
      >
        <H0
          mb={4}
          sx={{
            fontWeight: 700,
            fontSize: isTablet ? '30px' : '40px',
            wordBreak: 'keep-all',
          }}
        >
          나에게 맞는 멤버십 상품으로
          <br />
          정닥터닷컴의 다양한 서비스를 경험해 보세요
        </H0>

        <Grid
          container
          spacing={isMobile ? 0 : 3}
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'flex-start',
          }}
        >
          {/* Blue boxes on the left */}
          <Grid
            item
            xs={12}
            gap={3}
            md={4}
            mt={4}
            sx={{
              width: '100%',
              height: 'auto',
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              flexDirection: 'column',
            }}
          >
            <Box
              component="img"
              src="/static/membership2/blue-big.png"
              sx={{ objectFit: 'contain', width: '100%' }}
              alt="membership-blue"
            />
            <Box
              component="img"
              src="/static/membership2/blue-small-1.png"
              sx={{ objectFit: 'contain', width: '100%', cursor: 'pointer' }}
              onClick={() => setShowMembershipPurchaseModal(true)}
              alt="membership-blue-1"
            />
            <Box
              component="img"
              src="/static/membership2/blue-small-2.png"
              sx={{ objectFit: 'contain', width: '100%', cursor: 'pointer' }}
              onClick={() => setShowMembershipPurchaseModal(true)}
              alt="membership-blue-2"
            />
            <Box
              component="img"
              src="/static/membership2/blue-small-3.png"
              sx={{ objectFit: 'contain', width: '100%', cursor: 'pointer' }}
              onClick={() => setShowMembershipPurchaseModal(true)}
              alt="membership-blue-3"
            />
            <Box
              component="img"
              src="/static/membership2/blue-small-4.png"
              sx={{ objectFit: 'contain', width: '100%', cursor: 'pointer' }}
              onClick={() => setShowMembershipPurchaseModal(true)}
              alt="membership-blue-4"
            />
            <Box
              component="img"
              src="/static/membership2/blue-small-5.png"
              sx={{ objectFit: 'contain', width: '100%', cursor: 'pointer' }}
              onClick={() => setShowMembershipPurchaseModal(true)}
              alt="membership-blue-5"
            />
          </Grid>

          {/* Grey box in the middle */}
          <Grid
            item
            gap={3}
            xs={12}
            md={4}
            mt={4}
            sx={{
              width: '100%',
              height: 'auto',
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              flexDirection: 'column',
            }}
          >
            <Box
              component="img"
              src="/static/membership2/grey-big.png"
              sx={{ objectFit: 'contain', width: '100%' }}
              alt="membership-grey"
            />
            <Box
              component="img"
              src="/static/membership2/grey-small-1.png"
              sx={{ objectFit: 'contain', width: '100%', cursor: 'pointer' }}
              onClick={() => setShowMembershipPurchaseModal(true)}
              alt="membership-grey-1"
            />
            <Box
              component="img"
              src="/static/membership2/grey-small-2.png"
              sx={{ objectFit: 'contain', width: '100%', cursor: 'pointer' }}
              onClick={() => setShowMembershipPurchaseModal(true)}
              alt="membership-grey-2"
            />
            <Box
              component="img"
              src="/static/membership2/grey-small-3.png"
              sx={{ objectFit: 'contain', width: '100%', cursor: 'pointer' }}
              onClick={() => setShowMembershipPurchaseModal(true)}
              alt="membership-grey-3"
            />
            <Box
              component="img"
              src="/static/membership2/grey-small-4.png"
              sx={{ objectFit: 'contain', width: '100%', cursor: 'pointer' }}
              onClick={() => setShowMembershipPurchaseModal(true)}
              alt="membership-grey-4"
            />
            <Box
              component="img"
              src="/static/membership2/grey-small-5.png"
              sx={{ objectFit: 'contain', width: '100%', cursor: 'pointer' }}
              onClick={() => setShowMembershipPurchaseModal(true)}
              alt="membership-grey-5"
            />
          </Grid>

          {/* Purple box on the right */}
          <Grid
            item
            gap={3}
            xs={12}
            md={4}
            mt={4}
            sx={{
              width: '100%',
              height: 'auto',
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              flexDirection: 'column',
            }}
          >
            <Box
              component="img"
              src="/static/membership2/purple-big.png"
              sx={{ objectFit: 'contain', width: '100%' }}
              alt="membership-purple"
            />
            <Box
              component="img"
              src="/static/membership2/purple-small-1.png"
              sx={{ objectFit: 'contain', width: '100%', cursor: 'pointer' }}
              onClick={() => setShowMembershipPurchaseModal(true)}
              alt="membership-purple-1"
            />
            <Box
              component="img"
              src="/static/membership2/purple-small-2.png"
              sx={{ objectFit: 'contain', width: '100%', cursor: 'pointer' }}
              onClick={() => setShowMembershipPurchaseModal(true)}
              alt="membership-purple-2"
            />
            <Box
              component="img"
              src="/static/membership2/purple-small-3.png"
              sx={{ objectFit: 'contain', width: '100%', cursor: 'pointer' }}
              onClick={() => setShowMembershipPurchaseModal(true)}
              alt="membership-purple-3"
            />
            <Box
              component="img"
              src="/static/membership2/purple-small-4.png"
              sx={{ objectFit: 'contain', width: '100%', cursor: 'pointer' }}
              onClick={() => setShowMembershipPurchaseModal(true)}
              alt="membership-purple-4"
            />
            <Box
              component="img"
              src="/static/membership2/purple-small-5.png"
              sx={{ objectFit: 'contain', width: '100%', cursor: 'pointer' }}
              onClick={() => setShowMembershipPurchaseModal(true)}
              alt="membership-purple-5"
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

const TextSection = () => {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <SurveyModal showModal={showModal} setShowModal={setShowModal} />

      <Grid
        sx={{
          textAlign: 'center',
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          alignItems: 'center',
          maxWidth: '1100px',
          width: '100%',
          margin: '0 auto',
        }}
      >
        <Grid
          container
          gap={isTablet ? 0 : 3}
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'flex-start',
            width: '100%',
          }}
        >
          <Grid
            item
            xs={11}
            gap={3}
            mt={4}
            sx={{
              width: '100%',
              height: '100%',
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              flexDirection: 'column',
            }}
          >
            <H2
              sx={{
                color: '#381F43',
                fontSize: isTablet ? '22px' : '26px',
                width: '100%',
                textAlign: 'left',
                fontWeight: 800,
              }}
            >
              공지사항
            </H2>

            <H5
              sx={{
                color: '#381F43',
                fontSize: isTablet ? '18px' : '22px',
                textAlign: 'left',
                width: '100%',
                fontWeight: 700,
              }}
            >
              1. 해당 회원제도는 설계사 개인영업에 필요한 업무자료및 정보를
              제공해 주기 위함입니다.
            </H5>

            <H5
              sx={{
                color: '#381F43',
                fontSize: isTablet ? '18px' : '22px',
                textAlign: 'left',
                width: '100%',
                fontWeight: 700,
              }}
            >
              2. 관리직 또는 대표자인 경우에는 사전에 반드시 고지후에 신청을 해
              주셔야 됩니다. <br />
              <span style={{ fontWeight: 700, color: '#920606' }}>
                이후 해당건이 확인될 경우 10배의 회원제 금액이 부가됩니다.
              </span>
            </H5>

            <H5
              sx={{
                color: '#381F43',
                fontSize: isTablet ? '18px' : '22px',
                textAlign: 'left',
                width: '100%',
                fontWeight: 700,
              }}
            >
              3. 회원제 등업상향 즉시 환불 규정은 적용되지 않습니다.
            </H5>

            <H5
              sx={{
                color: '#381F43',
                fontSize: isTablet ? '18px' : '22px',
                textAlign: 'left',
                width: '100%',
                fontWeight: 700,
              }}
            >
              4. 유튜브및 온라인 채널, 카카오톡 채팅방 운영자및 관련자들은
              회원제 신청이 불가합니다.
            </H5>

            <H5
              sx={{
                color: '#381F43',
                fontSize: isTablet ? '18px' : '22px',
                textAlign: 'left',
                width: '100%',
                fontWeight: 700,
              }}
            >
              5. 위의 4가지 사항에 충분하게 인지되었고, 동의가 되었다는 전제하에
              회원제 가입은 최종 체결이 됩니다.
            </H5>

            <H5
              sx={{
                color: '#920606',
                fontSize: isTablet ? '18px' : '22px',
                textAlign: 'left',
                width: '100%',
                fontWeight: 700,
              }}
            >
              6. 골드 및 다이아 회원권의 경우 6개월 구매시 1개월 이용 추가
              증정/12개월 구매시 2개월이용을 추가로 증정합니다
            </H5>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

const CardNewsSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));
  const [showMembershipPurchaseModal, setShowMembershipPurchaseModal] =
    useState(false);

  return (
    <>
      <MembershipPurchaseModal
        showModal={showMembershipPurchaseModal}
        setShowModal={setShowMembershipPurchaseModal}
      />

      <Grid
        sx={{
          textAlign: 'center',
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          alignItems: 'center',
          maxWidth: '1100px',
          width: '100%',
          margin: '0 auto',
        }}
      >
        {/* Header Section */}
        <Box sx={{ mb: 4 }}>
          <H2
            sx={{
              fontSize: isTablet ? '24px' : '32px',
              fontWeight: 700,
              background: 'linear-gradient(90deg, #381F43 0%, #8D4EA9 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              textFillColor: 'transparent',
              mb: 4,
            }}
          >
            실버 & 골드
            <br />
            나만의 카드뉴스 다운로드! 월 30회!!
          </H2>

          {/* Folder Icon */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mb: 4,
            }}
          >
            <Box
              sx={{
                display: 'inline-block',
                position: 'relative',
                '& img': {
                  display: 'block',
                  position: 'relative',
                  zIndex: 2,
                },
                '&::after': {
                  content: '""',
                  display: 'block',
                  position: 'absolute',
                  left: '50%',
                  bottom: '-40px',
                  transform: 'translateX(-50%)',
                  width: '320px',
                  height: '70px',
                  background: '#F5EDC1',
                  borderRadius: '50%',
                  filter: 'blur(24px)',
                  zIndex: 1,
                  opacity: 0.85,
                },
              }}
            >
              <img
                src="/static/3d-file.png"
                alt="card-news"
                width={260}
                height={260}
              />
            </Box>
          </Box>
        </Box>

        {/* Pricing Cards Row */}
        <Grid container spacing={isMobile ? 2 : 3} sx={{ mb: 4 }}>
          {/* Basic Card */}
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                backgroundColor: '#F5F5F5',
                borderRadius: '20px',
                padding: '24px 20px',
                textAlign: 'left',
                position: 'relative',
                minHeight: '180px',
              }}
            >
              <Box>
                <Box
                  sx={{
                    color: '#666',
                    fontSize: '14px',
                    fontWeight: 600,
                    display: 'inline-block',
                    mb: 1,
                  }}
                >
                  체험회원권
                </Box>
                <H2
                  sx={{
                    fontSize: '20px',
                    fontWeight: 700,
                    color: '#333',
                    mb: 1,
                    lineHeight: 1.3,
                  }}
                >
                  카드뉴스 30건(초과불가)
                  <br />
                  VAT별도
                </H2>
              </Box>
              <FlexRowAlign justifyContent="space-between">
                <H0
                  sx={{
                    fontSize: '28px',
                    fontWeight: 800,
                    color: '#333',
                    mb: 0.5,
                  }}
                >
                  100,000원
                </H0>
                <Box
                  component="button"
                  onClick={() => setShowMembershipPurchaseModal(true)}
                  sx={{
                    backgroundColor: '#373737',
                    color: 'white',
                    border: 'none',
                    borderRadius: '12px',
                    padding: '8px 12px',
                    fontSize: '16px',
                    fontWeight: 600,
                    cursor: 'pointer',
                    width: '120px',
                    '&:hover': {
                      backgroundColor: '#555',
                    },
                  }}
                >
                  구매하기
                </Box>
              </FlexRowAlign>
            </Box>
          </Grid>

          {/* Silver Card */}
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                backgroundColor: '#E2EBFF',
                borderRadius: '20px',
                padding: '24px 20px',
                textAlign: 'left',
                position: 'relative',
                minHeight: '180px',
              }}
            >
              <Box>
                <Box
                  sx={{
                    color: '#001546',
                    fontSize: '14px',
                    fontWeight: 600,
                    display: 'inline-block',
                    mb: 1,
                  }}
                >
                  실버회원권
                </Box>
                <H2
                  sx={{
                    fontSize: '20px',
                    fontWeight: 700,
                    color: '#001546',
                    mb: 1,
                    lineHeight: 1.3,
                  }}
                >
                  카드뉴스 30건(초과불가)
                  <br />
                  VAT별도
                </H2>
              </Box>
              <FlexRowAlign justifyContent="space-between">
                <H0
                  sx={{
                    fontSize: '28px',
                    fontWeight: 800,
                    color: '#001546',
                    mb: 0.5,
                  }}
                >
                  50,000원
                </H0>
                <Box
                  component="button"
                  onClick={() => setShowMembershipPurchaseModal(true)}
                  sx={{
                    backgroundColor: '#001546',
                    color: 'white',
                    border: 'none',
                    borderRadius: '12px',
                    padding: '8px 12px',
                    fontSize: '16px',
                    fontWeight: 600,
                    cursor: 'pointer',
                    width: '120px',
                    '&:hover': {
                      backgroundColor: '#003366',
                    },
                  }}
                >
                  구매하기
                </Box>
              </FlexRowAlign>
            </Box>
          </Grid>

          {/* Gold Card */}
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                backgroundColor: '#FFF9DF',
                borderRadius: '20px',
                padding: '24px 20px',
                textAlign: 'left',
                position: 'relative',
                minHeight: '180px',
              }}
            >
              <Box>
                <Box
                  sx={{
                    color: '#462B00',
                    fontSize: '14px',
                    fontWeight: 600,
                    display: 'inline-block',
                    mb: 1,
                  }}
                >
                  골드회원권
                </Box>
                <H2
                  sx={{
                    fontSize: '20px',
                    fontWeight: 700,
                    color: '#462B00',
                    mb: 1,
                    lineHeight: 1.3,
                  }}
                >
                  카드뉴스 30건(초과불가)
                  <br />
                  VAT별도
                </H2>
              </Box>
              <FlexRowAlign justifyContent="space-between">
                <H0
                  sx={{
                    fontSize: '28px',
                    fontWeight: 800,
                    color: '#462B00',
                    mb: 0.5,
                  }}
                >
                  20,000원
                </H0>
                <Box
                  component="button"
                  onClick={() => setShowMembershipPurchaseModal(true)}
                  sx={{
                    backgroundColor: '#462B00',
                    color: 'white',
                    border: 'none',
                    borderRadius: '12px',
                    padding: '8px 12px',
                    fontSize: '16px',
                    fontWeight: 600,
                    cursor: 'pointer',
                    width: '120px',
                    '&:hover': {
                      backgroundColor: '#5D3800',
                    },
                  }}
                >
                  구매하기
                </Box>
              </FlexRowAlign>
            </Box>
          </Grid>
        </Grid>

        {/* Combined Package */}
        <Box
          sx={{
            backgroundColor: '#F5F5F5',
            borderRadius: '20px',
            padding: '24px 20px',
            width: '100%',
            mb: 8,
            textAlign: 'left',
            position: 'relative',
            minHeight: '180px',
          }}
        >
          <Box>
            <Box
              sx={{
                color: '#666',
                fontSize: '14px',
                fontWeight: 600,
                display: 'inline-block',
                mb: 1,
              }}
            >
              회원제 등급별 추가옵션
            </Box>
            <H2
              sx={{
                fontSize: '20px',
                fontWeight: 700,
                color: '#333',
                mb: 1,
                lineHeight: 1.3,
              }}
            >
              카드뉴스 30건(초과불가)
              <br />
              VAT별도
            </H2>
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              mb: isMobile ? 2 : 0,
              flexWrap: 'wrap',
              gap: 1,
            }}
          >
            <H0
              sx={{
                fontSize: '24px',
                fontWeight: 800,
                color: '#333',
              }}
            >
              100,000원 (체험단)
            </H0>
            <H0
              sx={{
                fontSize: '24px',
                fontWeight: 800,
                color: '#333',
              }}
            >
              50,000원 (실버회원)
            </H0>
            <H0
              sx={{
                fontSize: '24px',
                fontWeight: 800,
                color: '#333',
              }}
            >
              20,000원 (골드회원)
            </H0>
          </Box>
          <FlexRowAlign justifyContent="space-between">
            <H5 sx={{ fontSize: '15px', color: '#666', fontWeight: 600 }}>
              * 무제한 다운로드는{' '}
              <span style={{ color: '#ED1313' }}>다이아회원</span>을 이용
              해주세요
            </H5>
            <Box
              component="button"
              onClick={() => setShowMembershipPurchaseModal(true)}
              sx={{
                backgroundColor: '#373737',
                color: 'white',
                border: 'none',
                borderRadius: '12px',
                padding: '8px 12px',
                fontSize: '16px',
                fontWeight: 600,
                cursor: 'pointer',
                width: '260px',
                '&:hover': {
                  backgroundColor: '#555',
                },
              }}
            >
              구매하기
            </Box>
          </FlexRowAlign>
        </Box>

        {/* Service Details */}
        <Box sx={{ width: '100%', textAlign: 'left', mb: 6 }}>
          <H2
            sx={{
              fontSize: isTablet ? '20px' : '24px',
              fontWeight: 700,
              color: '#333',
              mb: 3,
              display: 'flex',
              alignItems: 'center',
            }}
          >
            📝 서비스 상세설명
          </H2>

          <Box sx={{ mb: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
              <Box
                sx={{
                  minWidth: '24px',
                  height: '24px',
                  backgroundColor: '#8D4EA9',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mr: 2,
                  mt: 0.5,
                }}
              >
                <H5
                  sx={{ color: 'white', fontSize: '14px', fontWeight: 'bold' }}
                >
                  1
                </H5>
              </Box>
              <Box>
                <H5 sx={{ fontWeight: 700, color: '#333', mb: 1 }}>
                  혼합설계플랜
                </H5>
                <H5
                  sx={{
                    color: '#666',
                    fontSize: '14px',
                    lineHeight: 1.6,
                    fontWeight: 500,
                    mb: 1,
                  }}
                >
                  국내보험사는 현재 36개 보험사로 구성되어있다.
                </H5>
                <H5
                  sx={{
                    color: '#8D4EA9',
                    fontSize: '14px',
                    lineHeight: 1.6,
                    fontWeight: 500,
                    mb: 1,
                  }}
                >
                  * 혼합설계는 여러보험사의 다양한 상품과 특약을 고객의 상황과
                  필요에 맞춰 최적의 조합으로 설계하는 방식을 말한다.
                  <br />
                  해당설계로 가성비 좋은 보험구성과 효율성을 높이는 역할을 할 수
                  있다.
                </H5>

                <H5
                  sx={{
                    color: '#666',
                    fontSize: '14px',
                    lineHeight: 1.6,
                    fontWeight: 500,
                  }}
                >
                  이 설계는 단순히 중복보험에 의존하기 보다 각 개인의 성별,
                  연령, 직업, 위험요소들을 고려하여 맞춤형으로 설계하는 것을
                  목표로 전문적인 지식이 필요하고 많은 시간이 소요되기에
                  실버/골드/다이아 회원제로 도움을 받을수있다.
                </H5>
              </Box>
            </Box>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
              <Box
                sx={{
                  minWidth: '24px',
                  height: '24px',
                  backgroundColor: '#8D4EA9',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mr: 2,
                  mt: 0.5,
                }}
              >
                <H5
                  sx={{ color: 'white', fontSize: '14px', fontWeight: 'bold' }}
                >
                  2
                </H5>
              </Box>
              <Box>
                <H5 sx={{ fontWeight: 700, color: '#333', mb: 1 }}>
                  보험사 영업자료 및 교안
                </H5>
                <H5
                  sx={{
                    color: '#666',
                    fontSize: '14px',
                    lineHeight: 1.6,
                    fontWeight: 500,
                  }}
                >
                  매달 생명/손해 보험사에서 제공하는 영업자료와 교안을 한꺼번에
                  취합해서 자료를 제공한다.
                </H5>
              </Box>
            </Box>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
              <Box
                sx={{
                  minWidth: '24px',
                  height: '24px',
                  backgroundColor: '#8D4EA9',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mr: 2,
                  mt: 0.5,
                }}
              >
                <H5
                  sx={{ color: 'white', fontSize: '14px', fontWeight: 'bold' }}
                >
                  3
                </H5>
              </Box>
              <Box>
                <H5 sx={{ fontWeight: 700, color: '#333', mb: 1 }}>
                  유튜브 생방송에서 진행되었던 PPT자료를 공유한다.
                </H5>
                <H5
                  sx={{
                    color: '#666',
                    fontSize: '14px',
                    lineHeight: 1.6,
                    fontWeight: 500,
                  }}
                >
                  실버회원은 방송참여 및 후기 작성시 제공되며 골드회원은
                  기본제공된다
                </H5>
              </Box>
            </Box>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
              <Box
                sx={{
                  minWidth: '24px',
                  height: '24px',
                  backgroundColor: '#8D4EA9',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mr: 2,
                  mt: 0.5,
                }}
              >
                <H5
                  sx={{ color: 'white', fontSize: '14px', fontWeight: 'bold' }}
                >
                  4
                </H5>
              </Box>
              <Box>
                <H5 sx={{ fontWeight: 700, color: '#333', mb: 1 }}>
                  카드뉴스 제작을 원하는 경우, 별도의 금액이 부과되며
                  당월기준으로 사용가능하다.
                </H5>
                <H5
                  sx={{
                    color: '#666',
                    fontSize: '14px',
                    lineHeight: 1.6,
                    fontWeight: 500,
                  }}
                >
                  회원제 이용 + 연락처기재
                </H5>
              </Box>
            </Box>
          </Box>
        </Box>

        {/* Notice Section */}
        <Box sx={{ width: '100%', textAlign: 'left' }}>
          <H2
            sx={{
              fontSize: isTablet ? '20px' : '24px',
              fontWeight: 700,
              color: '#2d3436',
              mb: 3,
              display: 'flex',
              alignItems: 'center',
            }}
          >
            📋 공지사항
          </H2>

          <Box sx={{ mb: 2 }}>
            <H5
              sx={{
                color: '#2d3436',
                fontSize: '14px',
                lineHeight: 1.6,
                fontWeight: 500,
                mb: 1,
              }}
            >
              1. 해당회원제도는 설계사 개인영업에 필요한 업무자료 및 정보를
              제공해 주기 위함입니다.
            </H5>
          </Box>

          <Box sx={{ mb: 2 }}>
            <H5
              sx={{
                color: '#2d3436',
                fontSize: '14px',
                lineHeight: 1.6,
                fontWeight: 500,
                mb: 1,
              }}
            >
              2. 관리직 또는 대표자인 경우에는 반드시 고지후에 신청을 해 주셔야
              됩니다.
            </H5>
          </Box>

          <Box sx={{ mb: 2 }}>
            <H5
              sx={{
                color: '#2d3436',
                fontSize: '14px',
                lineHeight: 1.6,
                fontWeight: 500,
                mb: 1,
              }}
            >
              3. 지적재산권 및 저작권에 해당되는 정보가 제공되어 회원제 등업상향
              즉시 환불 규정은 적용되지 않습니다.
            </H5>
          </Box>

          <Box sx={{ mb: 2 }}>
            <H5
              sx={{
                color: '#2d3436',
                fontSize: '14px',
                lineHeight: 1.6,
                fontWeight: 500,
                mb: 1,
              }}
            >
              4. 유튜브 및 온라인 채널, 카카오톡 채팅방 운영자 및 관련자들은
              회원제 신청이 불가합니다.
            </H5>
          </Box>

          <Box sx={{ mb: 2 }}>
            <H5
              sx={{
                color: '#2d3436',
                fontSize: '14px',
                lineHeight: 1.6,
                fontWeight: 500,
                mb: 1,
              }}
            >
              5. 1인1계정 사용이 가능하며, 회원제도는 본인 외 타인 사용금지된다.
              (적발시 민/형사상 책임)
            </H5>
          </Box>

          <Box sx={{ mb: 2 }}>
            <H5
              sx={{
                color: '#2d3436',
                fontSize: '14px',
                lineHeight: 1.6,
                fontWeight: 500,
                mb: 1,
              }}
            >
              6. 위의 5가지 사항에 충분하게 인지되었고, 동의가 되었다는 전제하에
              회원제 가입은 최종체결이 됩니다.
            </H5>
          </Box>

          <Box sx={{ mb: 2 }}>
            <H5
              sx={{
                color: '#2d3436',
                fontSize: '14px',
                lineHeight: 1.6,
                fontWeight: 500,
                mb: 1,
              }}
            >
              7.
              <span style={{ color: '#8D4EA9' }}>
                회원제 결제시 6개월 구매시 1개월 이용추가 증정, 12개월 구매시
                2개월 이용 추가 증정
              </span>
            </H5>
          </Box>
        </Box>
      </Grid>
    </>
  );
};
